"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UTM_PARAMETER_Properties = void 0;
const _UtmParametersProperties = ['utm_source', 'utm_medium'];
exports.UTM_PARAMETER_Properties = _UtmParametersProperties;
//# sourceMappingURL=UtmParameters.js.map